import { StateCreator } from "zustand";
import { WidgetStore, ConnectionState, ConnectionActions } from "../types";

const initialConnectionState: ConnectionState = {
  connectionStatus: "disconnected",
  conversationId: null,
  backendSessionId: null,
};

export const createConnectionSlice: StateCreator<
  WidgetStore,
  [],
  [],
  ConnectionState & ConnectionActions
> = (set) => ({
  ...initialConnectionState,
  setConnectionStatus: (connectionStatus) => set({ connectionStatus }),
  setConversationId: (conversationId) => set({ conversationId }),
  setBackendSessionId: (backendSessionId) => set({ backendSessionId }),
  resetConnection: () => set(initialConnectionState),
});
